<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="投票管理" />
		<el-form ref="form" :model="form" label-width="200px">
			<div class="formBox">
				<el-form-item label="投票管理共()个投票">
					<el-input class="mingc" v-model="form.name" placeholder="请输入活动名称"></el-input>
				</el-form-item>
				<el-form-item class="sx">
					<el-button type="primary" @click="sou">筛选</el-button>
				</el-form-item>
				<el-form-item class="tp">
					<el-button type="primary" @click="addTouP">创建投票</el-button>
				</el-form-item>
			</div>
			<div class="countBox" v-if="hasList">
				<div class="box" v-for=" item in data" :key="item.id">
					<div class="picBox">
						<span v-if="item.tpState == true" class="ts">进行中</span>
						<span v-else class="ts">已过期</span>
						<img :src="imgurl" alt="" :onerror="error_img">
					</div>
					<div class="boxText">
						<span class="id">ID：{{item.id}}</span>
						<!-- 默认活动标题（创建后请修改）</ -->
						<h2>{{item.title ? item.title : '默认活动标题（创建后请修改）'}} </h2>
						<span class="time">创建时间：{{item.addtime}}</span>
						<span class="time">投票开始时间：{{item.vote_time}} —— 投票截止时间：{{item.vote_time_end}}</span>
						<div class="iconBoxs">
							<div class="icons">
								<i></i>
								选手：{{item.vote_player_num}}
							</div>
							<div class="icons">
								<i></i>
								票数：{{item.vote_player_sum}}
							</div>
							<div class="icons">
								<i></i>
								访问量：{{item.view}}
							</div>
						</div>
						<div class="btnBox">
							<el-button type="primary" @click="handleEdit(item.id)">编辑</el-button>
							<el-button type="primary" @click="xuanshou(item.id)">参与选手</el-button>
							<el-button type="primary"  @click="fenxiang(item.id)">分享</el-button>
							<el-button type="primary" @click="deltp(item.id)">删除</el-button>

							<!-- <el-select placeholder="分享">
								<el-option label="区域一" value="shanghai"></el-option>
								<el-option label="区域二" value="beijing"></el-option>
							</el-select> -->
							<!-- <el-button type="primary" @click="addXuanS(item.id)">添加选手</el-button> -->

						</div>
					</div>
				</div>
			</div>
			<div class="countBox" v-else>
				<div class="zwts">
					没有找到~
				</div>
			</div>
			<el-dialog
			  title="提示"
			  :visible.sync="dialogVisible"
			  width="30%"
			  :before-close="handleClose">
			  <span>{{}}</span>
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="dialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			  </span>
			</el-dialog>
		</el-form>
		<el-pagination background layout="prev, pager, next" :total="total" :page-size="15" hide-on-single-page
			@current-change="currentChange" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					name: "哈哈"
				},
				count:'',
				data: [],
				p: 1,
				total: 0,
				a: 1,
				imgurl: '',
				error_img: 'this.src="' + require('../../assets/img/mr.jpg') + '"',
				hasList: true,
				times: '',
				tpState: true,
				vote_time: '',
				vote_time_end: '',
				dialogVisible: false
			}
		},
		created() {
			this.getData()
			this.times = Date.parse(new Date()) / 1000
		},
		methods: {
			fenxiang(){
				dialogVisible = true
			},
			getTime(value) {
				let date = new Date(parseInt(value))
				let y = date.getFullYear()
				let MM = date.getMonth() + 1
				MM = MM < 10 ? ('0' + MM) : MM
				let d = date.getDate()
				d = d < 10 ? ('0' + d) : d
				let h = date.getHours()
				h = h < 10 ? ('0' + h) : h
				let m = date.getMinutes()
				m = m < 10 ? ('0' + m) : m
				let s = date.getSeconds()
				s = s < 10 ? ('0' + s) : s
				return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
			},
			getData() {
				this.$axios.post('Exhibition-Admin-getVoteList', {
					// p: this.p
				}).then(data => {
					let that = this
					// this.count = data.length
					// this.total = Number(data.count)
					this.data = data
					this.data.forEach(function(item) {
						if (item.vote_time_end < that.times) {
							item.tpState = false
						} else {
							item.tpState = true
						}


						let date = new Date(parseInt(item.vote_time_end * 1000))
						let y = date.getFullYear()
						let MM = date.getMonth() + 1

						MM = MM < 10 ? ('0' + MM) : MM
						let d = date.getDate()
						d = d < 10 ? ('0' + d) : d
						let h = date.getHours()
						h = h < 10 ? ('0' + h) : h
						let m = date.getMinutes()
						m = m < 10 ? ('0' + m) : m
						let s = date.getSeconds()
						s = s < 10 ? ('0' + s) : s

						let date2 = new Date(parseInt(item.vote_time * 1000))
						let y2 = date2.getFullYear()
						let MM2 = date2.getMonth() + 1

						MM2 = MM2 < 10 ? ('0' + MM2) : MM2
						let d2 = date2.getDate()
						d2 = d2 < 10 ? ('0' + d2) : d2
						let h2 = date2.getHours()
						h2 = h2 < 10 ? ('0' + h2) : h2
						let m2 = date2.getMinutes()
						m2 = m2 < 10 ? ('0' + m2) : m2
						let s2 = date2.getSeconds()
						s2 = s2 < 10 ? ('0' + s2) : s2

						item.vote_time = y2 + '-' + MM2 + '-' + d2 + ' ' + h2 + ':' + m2 + ':' + s2
						item.vote_time_end = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s


					})
					this.imgurl = data.photo ? this.$store.state.IMG_URL + data.photo : ''
				})
			},
			handleEdit(id) {
				this.$router.push(`/vote/revise?id=${id}`)

			},
			currentChange(page) {
				this.p = page
				this.getData()
			},
			sou() {
				// 筛选
				this.$axios.post('Exhibition-Admin-getVoteList', {
					key: this.form.name
				}).then(data => {
					if (data.length <= 0) {
						this.data = data
						this.hasList = false
					}
					this.data = data

				})

			},
			addXuanS(id) {
				this.$router.push(`/vote/addXS?id=${id}`)
			},
			// 添加投票
			addTouP(id) {
				this.$router.push(`/vote/release?id=${id}`)
			},
			xuanshou(id) {
				// 选手列表
				this.$router.push(`/player?id=${id}`)

			},
			deltp(id) {
				this.$confirm('确定删除吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.post('Exhibition-Admin-saveFieldInfo', {
						id: id,
						model: 'Vote',
						user_id: this.$store.state.USER_ID,
						field: "state",
						value: '3',
					}).then(data => {
						if (data.code == 200) {
							this.$message.success('删除成功')
							this.getData()
						} else {
							this.$message.success(data.msg)
						}

					})
				}).catch(() => {})
			}
		}
	}
</script>

<style scoped>
	.o-wrap {
		padding-bottom: 20px;
	}

	.o-wrap>>>.el-form-item__content {
		margin-left: 200px !important;
	}

	.mingc {
		width: 300px;
	}

	.formBox {
		display: flex;
	}

	.sx {
		margin-left: -132px;
	}

	.tp {
		margin-left: -168px;
	}

	.box {
		/* width: 880px; */
		margin-bottom: 40px;
		display: flex;
		align-items: center;
	}

	.picBox {
		position: relative;
	}

	.picBox .ts {
		position: absolute;
		left: 8px;
		right: 0;
		top: 8px;
		z-index: 9999;
		width: 50px;
		border: 1px solid;
		padding: 5px 5px;
		text-align: center;
		border-radius: 20px;
		background: rgba(0, 0, 0, 0.5);
		color: #fff;
	}

	.picBox,
	.picBox img {
		width: 373px;
		height: 216px;
	}

	.boxText {
		/* width: 450px; */
		margin-left: 22px;
		font-size: 16px;
	}

	.box h2 {
		font-size: 20px;
		margin: 10px 0;
	}

	.box span {
		display: block;
	}

	.time {
		margin-top: 16px;
	}

	.iconBoxs {
		width: 320px;
		margin-top: 25px;
		display: flex;
		justify-content: space-between;
	}

	.btnBox {
		margin-top: 20px;
		display: flex;
	}

	.el-select {
		width: 90px;
		margin: 0 30px;
	}

	.countBox {
		margin-left: 60px;
	}

	/* .el-button+span {
		margin-left: 10px;
	}

	.el-pagination {
		text-align: center;
		margin-top: 20px;
	} */
	.zwts {
		text-align: center;
		font-size: 23px;
		color: #ccc;
		padding: 70px;
	}
</style>
